module.exports = __webpack_public_path__ + "static/magento-demos@2x-0cfe2d27e5994babe3777338b8323e9c.png";